module.exports = ".product-image-container img {\n  width: 100%;\n}\n"